import React, { useState } from "react";
import { Bot } from "lucide-react";
import { cn } from "@/lib/utils";

interface LogoProps {
  logoUrl?: string;
  logoName?: string;
}

const Logo = ({ logoUrl, logoName = "MRS IA" }: LogoProps) => {
  const [imageError, setImageError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const handleImageError = () => {
    setImageError(true);
    setIsLoading(false);
    console.error("Erro ao carregar o logo:", logoUrl);
  };

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  return (
    <div className="flex flex-col items-center space-y-2 relative">
      {!imageError && logoUrl ? (
        <>
          {isLoading && (
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
            </div>
          )}
          <img
            src={logoUrl}
            alt="Logo"
            className={cn(
              "h-20 w-20 object-contain transition-opacity duration-200",
              isLoading ? "opacity-0" : "opacity-100"
            )}
            onError={handleImageError}
            onLoad={handleImageLoad}
          />
        </>
      ) : (
        <Bot className="h-20 w-20 text-primary animate-in fade-in-0" />
      )}
      <span className="text-xl font-bold text-primary animate-in fade-in-50 duration-500">
        {logoName}
      </span>
    </div>
  );
};

export default Logo;